import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
import { computed } from 'vue';
import store from '@/store';
import { auth } from '@/utils/app';
export default {
  setup(__props) {
    const isLogin = computed(() => {
      return store.state.isApp && store.state.token.length == 0;
    });

    const login = () => {
      auth();
    };

    return (_ctx, _cache) => {
      return _unref(isLogin) ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "login-view",
        onClick: login
      })) : _createCommentVNode("", true);
    };
  }

};